import type { FeedSort } from "./types"

export const feedKeys = {
	all: ["feed"] as const,
	// Лента карточек: cardFeeds() — префикс категории (для инвалидации разом
	// обеих sort-вариаций), cardFeed(sort) — конкретный ключ страницы.
	cardFeeds: () => [...feedKeys.all, "card-feed"] as const,
	cardFeed: (sort: FeedSort) => [...feedKeys.cardFeeds(), sort] as const,
	dailyQuestion: () => [...feedKeys.all, "daily-question"] as const,
	dailyQuestionFeed: (sort: FeedSort) =>
		[...feedKeys.dailyQuestion(), "feed", sort] as const,
	// mutationKey star-мутации: скоуп по (category, sort) — счётчик isMutating
	// в onSettled должен видеть только другие star-мутации ЭТОЙ же ленты, не
	// чужие (like/submit-answer/star другой ленты).
	starMutation: (category: "regular" | "qotd", sort: FeedSort) =>
		[...feedKeys.all, "star", category, sort] as const,
} as const
